_initMetaviewport();
_initLinks();

function _initMetaviewport() {
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement("style");
        msViewportStyle.appendChild(
            document.createTextNode(
                "@-ms-viewport{width:auto!important}"
            )
        );
        document.getElementsByTagName("head")[0].
        appendChild(msViewportStyle);
    }
    var f = document.getElementsByTagName("html"),
        e = f.length ? f[0].className : "",
        c = e.indexOf("ie7") > -1,
        b = e.indexOf("ie8") > -1,
        d;
    if (c || b) {
        return
    }

    function a() {
        try {
            document.querySelector('meta[name="viewport"]').setAttribute("content", "width=device-width, initial-scale=1")
        } catch (error) {
            // not all browsers support this selector
        }
    }
    a();
    jQuery(window).resize(function() {
        clearTimeout(d);
        d = setTimeout(a, 200)
    });
}
function _initLinks() {
    jQuery("a[href$='.pdf'],a[href^='http://'],a[href^='www.'],a[href^='https://'],a[data-rel='external']").not("a[href^='http://" + location.hostname + "']").not("a[href^='https://" + location.hostname + "']").attr('target','_blank');
}